<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
      	
		<el-form :inline="true" class="backborder1 demo-form-inline" size="small" filterable clearable>
			<el-form-item style="width:22%">
            	<el-date-picker	v-model="query.date" type="daterange" style="width:100%"
              	range-separator="至"
              	start-placeholder="开始日期"
              	end-placeholder="结束日期"
              	value-format="yyyy-MM-dd" :unlink-panels="false" @change="ischange=true">
            	</el-date-picker>
            </el-form-item>
			<el-form-item style="width:10%">
            	<el-select v-model="query.ispay" placeholder="支付状态" clearable @change="ischange=true" style="width:100%">
	                <el-option v-for="(item,index) in paylists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
            </el-form-item>
			<el-form-item style="width:12%">
				<el-select v-model="query.status" placeholder="请选择订单状态" clearable @change="ischange=true">
	                <el-option v-for="(item,index) in statuslists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
			</el-form-item>
			<el-form-item>
                <el-input placeholder="订单号 / 店铺名 / 收货人姓名 / 收货人电话" v-model="query.key" clearable @change="ischange=true" style="width:100%"></el-input>
            </el-form-item>
			 <el-form-item>
            	<el-button size="small" type="primary" icon="el-icon-search" @click="getorderlists">查询</el-button>
            </el-form-item>
			<el-form-item>
				<el-button size="small" type="warning" icon="el-icon-phone-outline" @click="pushsetting">通知设置</el-button>
			</el-form-item>
			<el-form-item>
				<el-dropdown @command="sumTypeCkeck">
					<el-button icon="el-icon-download" size="small" type="success">导出</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(item,index) in orderexportdata" v-text="item.name" :command="item.id" :key="index"></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-form-item>
		</el-form>

		<div class="backborder2" style="margin-top:10px">
			<el-table :data="orderlists" style="width:100%" v-loading="orderLoading">
				<el-table-column type="expand">
					<template slot-scope="props">
					<div style="float:left;width:100%">
						<span style="float:left;margin-right:3%">收货人：{{props.row.username}}</span>
						<span style="float:left;margin-right:3%">收货人电话：{{props.row.phone}}</span>
						<el-button type="primary" size="mini" style="float:left;" @click="getpacks(props.row.id)">查看包裹</el-button><br/>
						<span style="float">地址信息：{{props.row.baseaddress}}</span><br/>
						<span style="float">详细地址：{{props.row.address}}</span><br/>
					</div>
					<el-table :data="props.row.goods">
						<el-table-column label="商品类型" width="100" align="center">
							<template slot-scope="props">
								<el-button type="success" size="mini" circle v-if="props.row.type==1">赞</el-button>
								<el-button type="danger" size="mini" circle v-if="props.row.type==2">京</el-button>
							</template>
						</el-table-column>
		                <el-table-column prop="name" label="商品名称"></el-table-column>
		                <el-table-column prop="spec" label="规格" width="150" align="center"></el-table-column>
		                <el-table-column prop="price" label="单价" width="100" align="center"></el-table-column>
		                <el-table-column prop="number" label="数量" width="100" align="center"></el-table-column>
		                <el-table-column prop="total" label="总价" width="100" align="center"></el-table-column>
	            	</el-table>
					</template>
				</el-table-column>
				<el-table-column label="订单编号" prop="ordersn" width="190"></el-table-column>
				<el-table-column label="店铺名" prop="shopname"></el-table-column>
				<el-table-column label="订单总额" prop="total" width="120" align="center"></el-table-column>
				<el-table-column label="邮费" prop="freight" width="120" align="center"></el-table-column>
				<el-table-column label="下单时间" prop="inputtime" width="150" align="center"></el-table-column>
				<el-table-column label="支付状态" width="100" align="center">
					<template slot-scope="props">
					    <el-tag type="danger" v-if="props.row.ispay==0">未支付</el-tag>
						<el-tag type="success" v-if="props.row.ispay==1">已支付</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="发货状态" width="100" align="center">
					<template slot-scope="props">
					    <el-tag type="danger" v-if="props.row.status==0">未发货</el-tag>
						<el-tag type="success" v-if="props.row.status==1">已发货</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100" align="center">
					<template slot-scope="props">
					    <el-button type="warning" icon="el-icon-check" circle size="mini" v-if="props.row.ispay==1 && props.row.status==0" @click="getsends(props.row)"></el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<div class="block">
		        <el-pagination 
		            @size-change="orderpageSizeChange" 
		          	@current-change="orderpageCurrentChange"
		          	:current-page="query.p"
		          	:page-sizes="[10, 20, 50]"
		          	:page-size="query.rollpage"
		          	layout="total, sizes, prev, pager, next, jumper"
		          	:total="total_rows">
		        </el-pagination>
	   		</div>
		</div>

		<!-- 获取发货方式列表 -->
		<el-dialog title="发货方式" :visible.sync="sendDialog"  width="15%" top="20vh">
			<el-col :span="24" v-for="(item,index) in sendlists" :key="index">
				<el-button @click="sendordergoods(item.agentid,item.type)" v-if="item.type==0" :type="item.issend==true ? 'primary' : 'info'" size="mini" style="width:100%;margin:0 0 10px 0">{{item.name}}</el-button>
				<el-button @click="sendordergoods(item.agentid,item.type)" v-if="item.type==2" :type="item.issend==true ? 'danger' : 'info'" size="mini" style="width:100%;margin:0 0 10px 0">{{item.name}}</el-button>
				<el-button @click="sendordergoods(item.agentid,item.type)" v-if="item.type==1" :type="item.issend==true ? 'success' : 'info'" size="mini" style="width:100%;margin:0 0 10px 0">{{item.name}}</el-button>
			</el-col>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="sendDialog = false" style="margin-top:20px">取 消</el-button>
			</div>
		</el-dialog>


		<!----- 包裹信息 -->
		<el-dialog title="包裹信息" :visible.sync="packdialog"  width="65%" top="10vh">
			<div v-if="packlists.length==0" style="text-align:center;float:left;width:96%;padding:2%;background:rgb(211,211,211,0.3);border-radius:6px;margin-bottom:20px">
				暂无已发货的包裹信息
			</div>
			<div v-for="(item,index) in packlists" :key="index" style="float:left;width:96%;padding:2%;background:rgb(211,211,211,0.3);border-radius:6px;margin-bottom:20px">
				<el-col :span="24"  style="font-weight:bold;">包裹{{item.numbers}}<i style="font-style:normal" v-if="item.agentname!=''">（{{item.agentname}}）</i></el-col>
				<el-col :span="24">
					<el-col :span="24" v-if="item.czdocuments!='' && item.czdocuments!=null">宠赞订单编号：{{item.czdocuments}}</el-col>
					<el-col :span="24" v-if="item.jddocuments!='' && item.jddocuments!=null">京东订单编号：{{item.jddocuments}}</el-col>
					<el-col :span="24">收货人：{{item.truename}}</el-col>
					<el-col :span="24">手机号码：{{item.phone}}</el-col>
					<el-col :span="24">收货地址：{{item.mainaddress}}</el-col>
					<el-col :span="24">详细地址：{{item.address}}</el-col>
				</el-col>
				<el-table :data="item.goods" style="float:left;width:100%;margin-top:10px">
					<el-table-column label="商品名称" prop="name"></el-table-column>
					<el-table-column label="数量" prop="numbers" align="center" width="100"></el-table-column>
					<el-table-column label="价格" prop="price" align="center" width="100"></el-table-column>
					<el-table-column label="小计" prop="total" align="center" width="100"></el-table-column>
				</el-table>

				<div class="packstyle" v-if="item.shipping.length>0">
				<ul style="padding:0;margin:0;float:left;width:100%">
					<li v-for="(tt,ii) in item.shipping" style="border-left:2px solid #e4e7ed;" v-if="tt.isend=='no'">
						<div class="icon" v-if="ii == 0"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
						<div class="time" v-if="ii == 0" style="color:red;">{{tt.content}}</div>
						<span class="content" v-if="ii == 0" style="color:red">{{tt.msgTime}}</span>
						<span class="content" v-if="ii == 0" style="color:red">操作人：{{tt.operator}}</span>

						<div class="icon" v-if="ii > 0"><img src="../../assets/time.png" /></div>
						<div class="time" v-if="ii > 0">{{tt.content}}</div>
						<span class="content" v-if="ii > 0">{{tt.msgTime}}</span>
						<span class="content" v-if="ii > 0">操作人：{{tt.operator}}</span>
					</li>
					<li v-for="(tt,ii) in item.shipping" v-if="tt.isend=='yes'">
						<div class="icon" v-if="ii == 0" style="color:red"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
						<div class="time" v-if="ii == 0" style="color:red">{{tt.content}}</div>
						<span class="content" v-if="ii == 0" style="color:red">{{tt.msgTime}}</span>
						<span class="content" v-if="ii == 0" style="color:red">操作人：{{tt.operator}}</span>

						<div class="icon" v-if="ii > 0"><img src="../../assets/time.png" /></div>
						<div class="time" v-if="ii > 0">{{tt.content}}</div>
						<span class="content" v-if="ii > 0">{{tt.msgTime}}</span>
						<span class="content" v-if="ii > 0">操作人：{{tt.operator}}</span>
					</li>
				</ul>
				</div>

			</div>
			<div slot="footer" class="dialog-footer" style="margin-top:20px">
		        <el-button size="medium" @click="packdialog = false">取 消</el-button>
		    </div>
		</el-dialog>

		<!--- 推送通知 --->
		<el-dialog title="推送设置" :visible.sync="pushDialog"  width="45%" top="15vh">
			<el-tag type="danger" style="margin-bottom:20px">温馨提示：以下设置主要用于商城下单后通过以下方式通知平台管理人员</el-tag>
			<div v-loading="pushloading" style="float:left;width:100%">
				<el-col v-for="(item,index) in pushlists" :key="index" :span="24" style="margin-bottom:20px;background:rgb(220,223,230,.4);padding:.5rem .3rem .3rem .5rem;border-radius:6px">
					<div style="border-bottom:1px solid #fff;padding:0 0 .5rem 0">
						<span style="font-weight:bold">{{item.name}}</span>
						<el-button type="warning" size="mini" circle icon="el-icon-plus"  @click="addpush(item.id)"  style="float:right;margin-right:1%"></el-button>
					</div>
					<table class="pushnotice" style="float:left;width:100%">
						<tr v-for="(tt,ii) in item.manager" :key="ii" style="padding:5px 0 5px 0;float:left;width:100%">
							<td width="20%">{{tt.truename}}</td>
							<td width="30%"><el-input v-model="tt.contact" @blur="changecontact(tt.type,tt.id,tt.contact)"></el-input></td>
							<td width="20%">
								<td width="20%"><el-button size="mini" type="danger" circle icon="el-icon-delete" @click="delpush(tt.id)" style="float:right"></el-button></td>
							</td>
						</tr>
					</table>
				</el-col>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="pushDialog = false" style="margin-top:20px">取 消</el-button>
			</div>
		</el-dialog>

		<!--- 新增用户信息 --->
		<el-dialog title="新增推送设置" :visible.sync="addpushDialog"  width="20%" top="15vh">
			<el-form :inline="true" size="small">
				<el-form-item style="width:100%">
					<el-input v-model="pushquery.truename" placeholder="联系人"></el-input>
				</el-form-item>
				<el-form-item style="width:100%">
					<el-input v-model="pushquery.contact" placeholder="手机号 / 微信"></el-input>
				</el-form-item>  
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="medium" @click="addpushs">确定</el-button>
				<el-button size="medium" @click="addpushDialog = false">取 消</el-button>
			</div>
		</el-dialog>

		<!------------- 订单列表导出信息 ----------------->	
	    <el-dialog title="导出订单信息确认" :visible.sync="outlistsputDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outexportlists" border v-loading="outlistsLoading">
		      	  	<el-table-column prop="ordernumber" label="订单编号"></el-table-column>
					<el-table-column prop="shopname" label="店铺名称"></el-table-column>
					<el-table-column prop="truename" label="收货人姓名"></el-table-column>
					<el-table-column prop="phone" label="收货电话"></el-table-column>
					<el-table-column prop="address" label="收货地址"></el-table-column>
					<el-table-column prop="ispay" label="是否支付"></el-table-column>
					<el-table-column prop="paystatus" label="支付类型"></el-table-column>
					<el-table-column prop="total" label="订单金额"></el-table-column>
					<el-table-column prop="freight" label="运费"></el-table-column>
					<el-table-column prop="orderreal" label="支付金额"></el-table-column>
					<el-table-column prop="inputtime" label="下单时间"></el-table-column>
					<el-table-column prop="updatetime" label="支付时间"></el-table-column>
					<el-table-column prop="status" label="订单状态"></el-table-column>
					<el-table-column prop="senddesc" label="出库订单号"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outlistsputDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

		<!------------- 订单商品详情列表导出信息 ----------------->	
	    <el-dialog title="导出订单信息确认" :visible.sync="outdetailsputDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="suredetailoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outexportdetails" border v-loading="outdetailsLoading">
		      	  	<el-table-column prop="ordernumber" label="订单编号"></el-table-column>
					<el-table-column prop="sku" label="sku"></el-table-column>
					<el-table-column prop="productname" label="商品名称"></el-table-column>
					<el-table-column prop="propertyname" label="规格"></el-table-column>
					<el-table-column prop="price" label="价格"></el-table-column>
					<el-table-column prop="numbers" label="数量"></el-table-column>
					<el-table-column prop="total" label="小计"></el-table-column>
					<el-table-column prop="orderreal" label="所属订单实付金额"></el-table-column>
					<el-table-column prop="goodsreal" label="商品实付金额"></el-table-column>
					<el-table-column prop="type" label="商品类型"></el-table-column>
					<el-table-column prop="inputtime" label="下单时间"></el-table-column>
					<el-table-column prop="pay_time" label="支付时间"></el-table-column>
					<el-table-column prop="status" label="订单状态"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outdetailsputDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="suredetailoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>


    </div>
    </transition>
</template>

<script>
export default { 
    data(){
	    return{
	        actionauth:'', //功能权限
	        transitionshow:true,
	        url:this.GLOBAL.domain+"Splitorder/index",
			query: {
				act:'lists',
				token:this.$cookies.get('token'),
				date:[],
				ispay:'',
				key:'',
				p:1,
				rollpage:10,
			},
			statuslists:[{id:1,name:'待发货'},{id:2,name:'已发货'}],
			paylists:[{id:1,name:'已支付'},{id:2,name:'未支付'}],
			orderlists:[],
			total_rows:0,
			orderLoading:false,
			ischange:false,
			sendDialog:false,
			sendlists:[],
			sendorderid:'',
			packlists:[],
			packdialog:false,
	        pushDialog:false,
			pushLoading:false,
			pushlists:[],
			addpushDialog:false,
			pushquery:{
	            act:'addpush',
	            token:this.$cookies.get('token'),
				truename:'',
				contact:'',
				type:'',
      	    },
			orderexportdata:[{id:1,name:'导出订单列表'},{id:2,name:'导出订单明细'}],
			outlistsputDialog:false,
			outlistsLoading:false,
			outexportlists:[],
			outdetailsputDialog:false,
			outdetailsLoading:false,
			outexportdetails:[],
			exporthead:[],
			exportfield:[],
			exportlists:[],
			exportname:'',

	    }
	},
    
	mounted(){  
	    this.getactionauth();	
		this.getorderlists(); //获取订单信息   
	},
  
	methods:{
		//重置表单
		reset() {
			this.$refs.create.resetFields();
		},
		    
		//获取功能权限
		getactionauth() {
			var data =this.$cookies.get('actionauth');
		    data=JSON.parse(data);
		    this.actionauth=data;
		},
		
		//获取分销订单信息
		getorderlists() {
			if(this.ischange==true) {
				this.query.p=1;
				this.query.rollpage=10;
			}

			this.orderLoading=true;
            var resource = this.$resource(this.url);
            resource.save(this.query).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
					this.orderLoading=false;
	            }else{
			        this.orderlists = JSON.parse(Base64.decode(res.data.Data));
		            this.total_rows=parseInt(res.data.count);
					this.orderLoading=false;
					if(this.ischange==true) this.ischange=false;
	            }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
				this.orderLoading=false;
            });
		},

		/** 下一页 **/
  	    orderpageSizeChange(val) {
  	        this.query.rollpage = val;
            this.getorderlists();
  	    },
  	    /** 下一页 **/
  	    orderpageCurrentChange(val) {
  	        this.query.p = val;
            this.getorderlists();
  	    },

		//获取订单的发货方式
		getsends(item) {
			this.sendorderid=item.id;
			this.sendDialog=true;
            var resource = this.$resource(this.url);
            resource.save({act:'sendlists',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	            }else{
			        this.sendlists = JSON.parse(Base64.decode(res.data.Data));
	            }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
		},

		//发货
		sendordergoods(agentid,type) {
            var resource = this.$resource(this.url);
            resource.save({act:'sendgoods',token:this.$cookies.get('token'),id:this.sendorderid,agentid:agentid,type:type}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	            }else{
					this.sendDialog=false;
			        this.getorderlists();
					this.$message.success('发货成功！');
	            }
            }).catch((res) => {
            	
            });
		},

		/** 获取包裹信息展示 **/
	    getpacks(id) {
			this.packdialog=true;
			var resource = this.$resource(this.url);
	        resource.query({act:'getpackdetail',token:this.$cookies.get('token'),orderid:id}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	            }else{
	                this.packlists = JSON.parse(Base64.decode(res.data.Data));

	            }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},

		/** 获取推送人员信息列表 **/
		pushsetting() {
			this.pushDialog=true;
			this.pushLoading=true;
			this.getpushlists();
		},

		/** 获取推送人员信息列表 **/
		getpushlists() {
			this.pushloading=true;
			var resource = this.$resource(this.url);		    
			resource.query({act:'getpushlists',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.pushloading=false;
				}else{
					this.pushlists = JSON.parse(Base64.decode(res.data.Data));
					this.pushloading=false;
				}
			}).catch((res) => {
				this.pushloading=false;
			});
		},

		/** 添加推送设置 **/
		addpush(type) {
			this.pushquery.type=type;
			this.pushquery.truename='';
			this.pushquery.contact='';
			this.addpushDialog=true;
		},

		/** 新增推送设置信息 **/
		addpushs() {
			var resource = this.$resource(this.url);		    
			resource.save(this.pushquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.addpushDialog=false;
					this.getpushlists();
				}
			}).catch((res) => {
				
			});
		},

		/** 删除推送设置信息 **/
		delpush(id) {
			var resource = this.$resource(this.url);		    
			resource.query({act:'delpush',id:id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getpushlists();
				}
			}).catch((res) => {
				
			});
		},


		/** 修改联系信息设置 **/
		changecontact(type,id,contact) {
			var resource = this.$resource(this.url);		    
			resource.save({act:'changepush',type:type,id:id,contact:contact,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.getpushlists();
				}else{
					this.getpushlists();
				}
			}).catch((res) => {
				this.getpushlists();
			});
		},

		/** 导出线上商城订单信息 **/
		sumTypeCkeck(val) {
			if(val==1) this.exportdatalist();
			if(val==2) this.exportdatadetail();
		},    
	    
		//导出销售订单列表
		exportdatalist() {
			this.outlistsputDialog=true;
			this.outlistsLoading=true;

			var resource = this.$resource(this.GLOBAL.exportUrl+'/Splitorder/index');
			resource.query({act:'exportorderlists',token: this.$cookies.get('token'),date:this.query.date,ispay:this.query.ispay,key:this.query.key}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.outlistsLoading=false;
				}else{
					this.outexportlists = JSON.parse(Base64.decode(res.data.Data));
					this.outlistsLoading=false;
				}
			}).catch((res) => {
				this.outlistsLoading=false;
			});
		},

		//导出销售订单详情列表信息
		exportdatadetail() {
			this.outdetailsputDialog=true;
			this.outdetailsLoading=true;
			var resource = this.$resource(this.GLOBAL.exportUrl+'/Splitorder/index');
			resource.query({act: 'exportorderdetails',token: this.$cookies.get('token'),date:this.query.date,ispay:this.query.ispay,key:this.query.key}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.outdetailsLoading=false;
				}else{
					this.outexportdetails = JSON.parse(Base64.decode(res.data.Data));
					this.outdetailsLoading=false;
				}
			}).catch((res) => {
				this.outdetailsLoading=false;
			});
		},

		//导出销售订单列表
		sureoutput() {    
			this.exporthead=['订单编号','店铺名称','收货人姓名','收货电话','收货地址','是否支付','支付类型','订单金额','运费','支付金额','下单时间','支付时间','订单状态','出库订单号','交易单号'];
			this.exportfield=['ordernumber','shopname','truename','phone','address','ispay','paystatus','total','freight','orderreal','inputtime','updatetime','status','senddesc','trade_no'];
			this.exportlists=this.outexportlists;
			this.exportname='联营分销订单列表';
			this.exportput();
			this.outlistsputDialog=false;		
		},

		//导出销售订单详情信息
		suredetailoutput() {	
			this.exporthead=['订单编号','店铺名称','收货人姓名','收货人电话','默认地址','详细地址','sku','商品名称','规格','价格','数量','小计','所属订单实付金额','商品实付小计','商品类型','下单时间','支付时间','订单状态','订单来源'];
			this.exportfield=['ordernumber','shopname','truename','phone','defaultaddress','address','sku','productname','propertyname','price','numbers','total','orderreal','goodsreal','type','inputtime','pay_time','status','linetype'];
			this.exportlists=this.outexportdetails;
			this.exportname='联营分销订单明细';
			this.exportput();
			this.outdetailsputDialog=false;	
		},


		/** 确认导出信息 **/
		exportput() {
			require.ensure([], () => {
				var { export_json_to_excel } = require('../../vendor/Export2Excel');
				var data = this.formatJson(this.exportfield, this.exportlists);
				export_json_to_excel(this.exporthead, data, this.exportname);
			})
		},
		
		//导出表格数据
		formatJson(filterVal, jsonData) {
	　　　　return jsonData.map(v => filterVal.map(j => v[j]));
	　　}, 


				        
    }
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.packstyle {float:left;margin-top:10px;background:#fff;border-radius:5px;padding:1rem 2% 1rem 2%;width:96%}
.packstyle li {padding:0 5% 1rem 0;float:left;width:100%;list-style-type:none}
.packstyle .icon {width:1.2rem;height:1.2rem;background:#e4e7ed;border-radius:50%;position:absolute;margin-left:-.65rem;margin-top:0}
.packstyle .icon img {width:100%;background:#fff}
.packstyle .time {float:left;margin-left:3%;margin-top:-.3rem;color:#303133;}
.packstyle .content {float:left;width:90%;margin-left:3%;color:#909399}
</style>



// WEBPACK FOOTER //
// src/components/mall/Splitorder.vue